<template>
  <div>
    <div class="profile_section user_pic_rating">
      <img alt="user_pic" width="135" src="@/assets/images/user.svg">
      <div class="user_info">
        <span class="user_name">{{ user_name }}</span>
        <span>{{ user_rating }} points</span>
        <div class="modals_section">
          <v-btn icon
                 small
                 :ripple="false"
                 @click="$refs.followingModal.openModal()"
                 color="blue">
            <v-icon>mdi-account-group</v-icon>
            {{ following.length }} following
          </v-btn>

          <v-btn icon
                 small
                 :ripple="false"
                 @click="$refs.followersModal.openModal()"
                 color="blue">
            <v-icon>mdi-account-group-outline</v-icon>
            {{ followers.length }} followers
          </v-btn>

          <v-btn icon
                 small
                 :ripple="false"
                 @click="loadSearchModal"
                 color="blue">
            <v-icon>mdi-account-search</v-icon>
            Search users
          </v-btn>
        </div>
      </div>

    </div>
    <SearchUserModal ref="followingModal"
                     @openSnackbar="openSnackbar"
                     :following-list="following"
                     :users-list="following"
                     :show-rating="false"
                     :on-create-user-follow="onCreateUserFollow"
                     :on-delete-user-follow="onDeleteUserFollow"/>
    <SearchUserModal ref="followersModal"
                     @openSnackbar="openSnackbar"
                     :following-list="following"
                     :users-list="followers"
                     :show-rating="false"
                     :on-create-user-follow="onCreateUserFollow"
                     :on-delete-user-follow="onDeleteUserFollow"/>
    <SearchUserModal ref="searchModal"
                     @openSnackbar="openSnackbar"
                     :following-list="following"
                     :users-list="usersList"
                     :show-rating="true"
                     :on-create-user-follow="onCreateUserFollow"
                     :on-delete-user-follow="onDeleteUserFollow"/>
  </div>
</template>

<script>
import SearchUserModal from "@/components/User/Modals/SearchUserModal";


export default {
  name: "UserInfo",
  components: {
    SearchUserModal
  },
  props: ['usersList',
    'user_name',
    'user_rating',
    'following',
    'followers',
    'onCreateUserFollow',
    'onDeleteUserFollow'
  ],

  methods: {
    openSnackbar(payload) {
      this.$emit('openSnackbar', {message: payload.message, type: payload.type})
    },

    async loadSearchModal() {
      await this.$emit('loadUsersList')
      this.$refs.searchModal.openModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.profile_section {
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;
  padding: 3vh;
  margin: 2vh;
  border-radius: 6px;
  width: 90vw;
}

.user_pic_rating {
  display: flex;
  align-items: center;
  margin-top: 10vh;
}

.user_name {
  font-weight: bold;
  margin-bottom: 1vh;
}

.user_info {
  margin-left: 2vw;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.modals_section {
  width: 100%;
  display: flex;
  justify-content: space-around;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin-left: 10vw;
  }

  .v-btn::before {
    background-color: transparent;
  }
}

.overflow-hidden {
  overflow: hidden;
}
</style>
